import React from 'react';
import { Button, Icon } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from '../../components/FieldRegionReport/RegionReport/RegionReport.css';

interface ConfirmationModalProps {
  confirmButtonText?: string;
  handleClickGoBack: () => void;
  handleClickConfirm: () => void;
  handleClickCancel: () => void;
  isLoading?: boolean;
  title: string;
  subTitle?: string;
  className?: string;
  confirmButtonMode?: 'primary' | 'secondary' | string;
  isWarningModal?: boolean;
}

const ConfirmationModal  = ({
  confirmButtonText,
  handleClickGoBack,
  handleClickConfirm,
  handleClickCancel,
  isLoading,
  title,
  subTitle,
  className = '',
  confirmButtonMode = 'primary',
  isWarningModal = false
}: ConfirmationModalProps) => (
    <div className={className} data-test-id="confirmation-modal">
      <div className={styles.confirmationTitle}>{title}</div>
      <div className={styles.confirmationSubTitle}>{subTitle}</div>
      <div className={styles.buttonContainer}>
        <Icon
          className={styles.closeModalIcon}
          glyph={Icon.set.REMOVE}
          onClick={handleClickCancel}
          testId="confirmation-modal-confirm-Icon"
        />
        <Button
          className={`${styles.goBackRegionReportButton} ${isWarningModal ? styles.centerButton : ''}`}
          data-test-id="confirmation-modal-go-back-button"
          isLoading={isLoading}
          mode="secondary"
          onClick={handleClickGoBack}
          type="button"
        >
          {getMessage('confirmationModal.goBack')}
        </Button>
        {!isWarningModal && (
          <Button
            data-test-id="confirmation-modal-confirm-button"
            isLoading={isLoading}
            mode={confirmButtonMode}
            onClick={handleClickConfirm}
            type="button"
          >
            {confirmButtonText}
          </Button>
        )}
      </div>
    </div>
  );

export default ConfirmationModal;
